import { ECheckoutError, EDistributorSource } from 'core/model/enums/checkout.enum';
import { ECustomerSource } from 'core/model/enums/customer.enum';
import { EServicesErrorCode } from 'core/model/enums/error-code.enum';

export const DELIVERY_CONTACT_NUMBER = '949449467';

export const PAYMENT_METHOD_NAME = {
  cash: 'Efectivo',
  transfer: 'Transferencia',
  credit: 'Credito',
};

export const TIME_MS_TO_RESTORE_SCROLL = 250;

export const NUMBER_OF_POST_ORDER_API_RETRIES = 2;
export const POST_ORDER_API_EXPONENTIAL_DELAY = 3000;

export const CHECKOUT_ERROR_BEHAVIOURS = {
  reviewMyOrdersBecauseOfDisconnectionError: {
    code: ECheckoutError.NETWORK_OR_TIMEOUT_ERROR,
    message: 'Se ha perdido la conexión, por favor dirígete Mis pedidos y confirma si tu pedido se ha generado.',
  },
};
export const CHECKOUT_ERROR_TO_HOME = [EServicesErrorCode.CHECKOUT_MINIMUM_SALE_AMOUNT_NOT_REACHED];
export const CHECKOUT_ERROR_BLOCK_CONTINUE = [
  EServicesErrorCode.CHECKOUT_BAD_USER_CONFIGURATION,
  EServicesErrorCode.CHECKOUT_DELIVERY_DATES_ERROR,
  EServicesErrorCode.CHECKOUT_NO_CODIMOD_SET,
  EServicesErrorCode.CHECKOUT_SCHEDULES_NOT_SET,
  EServicesErrorCode.CHECKOUT_THERE_ARE_NO_PRODUCTS,
];

export const CUSTOMER_SOURCE_CONFIG = {
  [ECustomerSource.HYBRID]: [
    {
      source: 'own',
      cart: 'alicorpCart',
      distributor: EDistributorSource.ALICORP,
      sourceId: ECustomerSource.DEX,
    },
    {
      source: 'thirdParty',
      cart: 'alliedCart',
      distributor: EDistributorSource.ALLIED,
      sourceId: ECustomerSource.APUDEX,
    },
  ],
  [ECustomerSource.DEX]: [
    {
      source: 'own',
      cart: 'generalCart',
      distributor: EDistributorSource.GENERAL,
      sourceId: ECustomerSource.DEX,
    },
  ],
  [ECustomerSource.APUDEX]: [
    {
      source: 'thirdParty',
      cart: 'generalCart',
      distributor: EDistributorSource.GENERAL,
      sourceId: ECustomerSource.APUDEX,
    },
  ],
} as const;

export const CHECKOUT_PARAMS_CONFIG = {
  [ECustomerSource.HYBRID]: {
    alicorp: 'alicorpPaymentMethodId',
    allied: 'alliedPaymentMethodId',
  },
  [ECustomerSource.DEX]: {
    alicorp: 'alicorpPaymentMethodId',
    allied: null,
  },
  [ECustomerSource.APUDEX]: {
    alicorp: null,
    allied: 'alliedPaymentMethodId',
  },
} as const;

export const CART_GROUPS_CONFIG = {
  [ECustomerSource.HYBRID]: {
    alicorp: 'alicorpItems',
    allied: 'alliedItems',
  },
  [ECustomerSource.DEX]: {
    alicorp: 'generalItems',
    allied: null,
  },
  [ECustomerSource.APUDEX]: {
    alicorp: null,
    allied: 'generalItems',
  },
} as const;

export type TCartKey = 'alicorpCart' | 'alliedCart' | 'generalCart';

export const PAYMENT_METHOD_SOURCE_CONFIG = {
  [ECustomerSource.DEX]: {
    dex: 'generalCart',
    apudex: null,
  },
  [ECustomerSource.APUDEX]: {
    dex: null,
    apudex: 'generalCart',
  },
  [ECustomerSource.HYBRID]: {
    dex: 'alicorpCart',
    apudex: 'alliedCart',
  },
} as const;
